export default "__VITE_ASSET__DdQWpjxL__"